$(function() {
	// Setup info popups (lightbox)
	infoPopup.init();
});

var infoPopup = (function () {

	var init = function () {
		var $infoPopupLinks = $("[data-action='display-popup']");
		var $infoPopups = $(".info-popup");
		var $body = $("body");

		// Init info popups
		$infoPopups.each(function () {
			var $popup = $(this);
			var $closeButton = $popup.find(".close");

			if ($closeButton.length) {
				$closeButton.click(function () {
					$body.removeClass("popped");
					$popup.removeClass("visible");
				});
			}

			if ($popup.hasClass("kiosk-mode")) {
				$popup.find(".content a").each(function () {
					var $link = $(this);
					$link.click(function () {
						return false;
					});
				});
			}
		});

		// Init popup links
		$infoPopupLinks.each(function () {
			var $link = $(this);

			// Assign click handler to link
			$link.click(function (e) {
				e.preventDefault();
				var popupId = $link.attr("href");
				var $popupToShow = $infoPopups.filter(popupId);
				if ($popupToShow) {
					$popupToShow.addClass("visible");
					$body.addClass("popped");
				}
			});
		});
	};

	return { init: init };

}());
